import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = {
  class: "grid min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-12"
};
const _hoisted_2 = {
  class: "lg:col-span-3"
};
const _hoisted_3 = {
  class: "flex min-h-0 flex-col lg:col-span-9"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_5 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
  class: "data-table-shell"
};
const _hoisted_9 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_10 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_11 = {
  class: "data-table-body"
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = {
  class: "flex items-center gap-3"
};
const _hoisted_14 = {
  class: "h-9 w-9 shrink-0 overflow-hidden rounded-lg border border-slate-200 bg-slate-50"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center text-slate-300"
};
const _hoisted_17 = {
  class: "data-table-cell-title"
};
const _hoisted_18 = {
  class: "data-table-cell-meta"
};
const _hoisted_19 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_20 = ["title"];
const _hoisted_21 = {
  class: "data-table-td font-medium text-primary-600"
};
const _hoisted_22 = {
  class: "data-table-td is-center text-slate-600"
};
const _hoisted_23 = {
  class: "data-table-td is-center"
};
const _hoisted_24 = {
  class: "flex flex-col items-center gap-1"
};
const _hoisted_25 = ["title"];
const _hoisted_26 = {
  key: 1,
  class: "status-badge is-info",
  title: "存在待审草稿版本，可提交上架审批"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "data-table-td is-center"
};
const _hoisted_29 = ["onClick", "title"];
const _hoisted_30 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_31 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_32 = {
  class: "flex items-center justify-center gap-2"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick", "disabled", "title", "aria-label"];
const _hoisted_37 = ["onClick", "disabled", "title"];
const _hoisted_38 = ["onClick", "disabled", "title"];
const _hoisted_39 = {
  key: 1
};
const _hoisted_40 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4 shrink-0"
};
const _hoisted_41 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_42 = {
  class: "px-6 py-5 overflow-y-auto flex-1"
};
const _hoisted_43 = {
  class: "grid grid-cols-1 gap-4"
};
const _hoisted_44 = {
  class: "mt-2 flex items-center gap-4"
};
const _hoisted_45 = {
  class: "relative h-16 w-16 shrink-0 overflow-hidden rounded-lg border border-slate-200 bg-slate-50"
};
const _hoisted_46 = ["src"];
const _hoisted_47 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center text-slate-400"
};
const _hoisted_48 = {
  class: "flex flex-col gap-2"
};
const _hoisted_49 = {
  class: "cursor-pointer rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
};
const _hoisted_50 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_51 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4 shrink-0"
};
const _hoisted_52 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_53 = {
  class: "text-xs text-slate-500"
};
const _hoisted_54 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_55 = {
  class: "flex h-[70vh] min-h-0"
};
const _hoisted_56 = {
  class: "hidden w-28 shrink-0 flex-col gap-1 overflow-y-auto border-r border-slate-200 px-2 py-4 sm:flex"
};
const _hoisted_57 = ["onClick"];
const _hoisted_58 = {
  class: "space-y-6 p-6"
};
const _hoisted_59 = {
  class: "rounded-xl border border-slate-200 p-4"
};
const _hoisted_60 = {
  class: "mt-3 grid grid-cols-1 gap-3 lg:grid-cols-2"
};
const _hoisted_61 = {
  class: "mt-2 flex items-center gap-4"
};
const _hoisted_62 = {
  class: "relative h-16 w-16 shrink-0 overflow-hidden rounded-lg border border-slate-200 bg-slate-50"
};
const _hoisted_63 = ["src"];
const _hoisted_64 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center text-slate-400"
};
const _hoisted_65 = {
  class: "flex flex-col gap-2"
};
const _hoisted_66 = {
  class: "cursor-pointer rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
};
const _hoisted_67 = {
  key: 0
};
const _hoisted_68 = {
  class: "rounded-xl border border-slate-200 p-4"
};
const _hoisted_69 = {
  class: "mt-3 space-y-3"
};
const _hoisted_70 = {
  class: "mt-3 max-h-80 space-y-3 overflow-y-auto pr-1"
};
const _hoisted_71 = {
  class: "flex items-start gap-3"
};
const _hoisted_72 = {
  class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-sm font-semibold text-white shadow-sm"
};
const _hoisted_73 = {
  class: "flex-1 space-y-3"
};
const _hoisted_74 = ["onUpdate:modelValue"];
const _hoisted_75 = ["onUpdate:modelValue"];
const _hoisted_76 = ["onClick"];
const _hoisted_77 = {
  key: 0,
  class: "flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-slate-200 bg-slate-50/50 p-8"
};
const _hoisted_78 = {
  class: "grid grid-cols-2 gap-3"
};
const _hoisted_79 = {
  class: "rounded-xl border border-slate-200 p-4"
};
const _hoisted_80 = {
  class: "mt-3 space-y-3"
};
const _hoisted_81 = {
  class: "lg:col-span-3"
};
const _hoisted_82 = {
  class: "lg:col-span-1"
};
const _hoisted_83 = {
  class: "mt-2 text-xs text-slate-700"
};
const _hoisted_84 = {
  class: "flex items-center gap-2 lg:col-span-1"
};
const _hoisted_85 = ["onUpdate:modelValue"];
const _hoisted_86 = {
  class: "flex items-center gap-2 lg:col-span-1"
};
const _hoisted_87 = {
  class: "text-xs text-slate-600"
};
const _hoisted_88 = {
  class: "lg:col-span-6 flex justify-end"
};
const _hoisted_89 = ["onClick"];
const _hoisted_90 = {
  key: 0,
  class: "rounded-lg border border-dashed border-slate-200 p-3 text-center text-xs text-slate-500"
};
const _hoisted_91 = {
  class: "rounded-xl border border-slate-200 p-4"
};
const _hoisted_92 = {
  class: "mt-3 space-y-4"
};
const _hoisted_93 = {
  class: "grid grid-cols-1 gap-3 lg:grid-cols-4"
};
const _hoisted_94 = ["onUpdate:modelValue"];
const _hoisted_95 = ["onUpdate:modelValue"];
const _hoisted_96 = ["onUpdate:modelValue"];
const _hoisted_97 = {
  key: 0,
  class: "mt-3 space-y-2"
};
const _hoisted_98 = {
  class: "lg:col-span-2"
};
const _hoisted_99 = ["onUpdate:modelValue"];
const _hoisted_100 = {
  key: 0,
  class: "grid grid-cols-2 gap-2 lg:col-span-2"
};
const _hoisted_101 = ["onUpdate:modelValue"];
const _hoisted_102 = ["onUpdate:modelValue"];
const _hoisted_103 = {
  key: 1,
  class: "grid grid-cols-2 gap-2 lg:col-span-2"
};
const _hoisted_104 = ["onUpdate:modelValue"];
const _hoisted_105 = ["onUpdate:modelValue"];
const _hoisted_106 = {
  key: 2,
  class: "lg:col-span-2"
};
const _hoisted_107 = ["onUpdate:modelValue"];
const _hoisted_108 = {
  class: "lg:col-span-2"
};
const _hoisted_109 = ["onUpdate:modelValue"];
const _hoisted_110 = {
  class: "flex items-end justify-end lg:col-span-6"
};
const _hoisted_111 = ["onClick"];
const _hoisted_112 = ["onClick"];
const _hoisted_113 = {
  key: 1,
  class: "mt-3 rounded-lg border border-dashed border-slate-200 bg-white p-3 text-xs text-slate-500"
};
const _hoisted_114 = {
  class: "mt-3 flex justify-end"
};
const _hoisted_115 = ["onClick"];
const _hoisted_116 = {
  class: "px-6 py-5 text-sm text-slate-600"
};
import { onMounted, reactive, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import ProductCategorySidebar from '@/components/ProductCategorySidebar.vue';
import RichTextField from '@/components/RichTextField.vue';
import ProductDetailModal from '@/components/ProductDetailModal.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import ProductPreviewModal from '@/components/ProductPreviewModal.vue';
import AppModal from '@/components/AppModal.vue';
import { createProduct, createProductCategory, deleteProduct, deleteProductCategory, getCustomerMaterialTypes, getProductCategories, getProductDetail, getProductPage, setProductHot, submitPublishApproval, submitUnpublishApproval, updateProduct, updateProductCategory } from '@/api';
import { getDept } from '@/api/dept';
import { uploadFile } from '@/api/file';
import DeptSelector from '@/components/DeptSelector/index.vue';
export default {
  __name: 'ProductManagement',
  setup(__props) {
    const resolveFileUrl = fileKey => {
      if (!fileKey) return '';
      if (/^https?:\/\//i.test(fileKey)) return fileKey;
      return `${process.env.VUE_APP_API_BASE_URL || ''}/${fileKey}`.replace(/\/+/g, '/').replace(':/', '://');
    };

    // 产品分类执行部门选择（DeptSelector 单选为 {id,name} 对象，同步纯 id 到 categoryForm）
    const categoryDeptSelection = ref(null);
    watch(categoryDeptSelection, val => {
      categoryForm.deptId = val ? typeof val === 'object' ? val.id : val : null;
    });

    // 待上传的图标文件（选择后暂存，保存时再上传）
    const categoryIconFile = ref(null);
    const categoryIconPreview = ref('');
    const categoryIconModified = ref(false);
    const productIconFile = ref(null);
    const productIconPreview = ref('');
    const productIconModified = ref(false);
    const handleIconSelect = (event, target) => {
      const file = event.target.files?.[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        event.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        ElMessage.warning('图片大小不能超过5MB');
        event.target.value = '';
        return;
      }
      if (target === 'category') {
        if (categoryIconPreview.value) URL.revokeObjectURL(categoryIconPreview.value);
        categoryIconFile.value = file;
        categoryIconPreview.value = URL.createObjectURL(file);
        categoryIconModified.value = true;
      } else {
        if (productIconPreview.value) URL.revokeObjectURL(productIconPreview.value);
        productIconFile.value = file;
        productIconPreview.value = URL.createObjectURL(file);
        productIconModified.value = true;
      }
      event.target.value = '';
    };
    const clearIconSelect = target => {
      if (target === 'category') {
        if (categoryIconPreview.value) URL.revokeObjectURL(categoryIconPreview.value);
        categoryIconFile.value = null;
        categoryIconPreview.value = '';
        categoryForm.icon = '';
        categoryIconModified.value = true;
      } else {
        if (productIconPreview.value) URL.revokeObjectURL(productIconPreview.value);
        productIconFile.value = null;
        productIconPreview.value = '';
        productForm.icon = '';
        productIconModified.value = true;
      }
    };
    const uploadIconIfNeeded = async target => {
      const file = target === 'category' ? categoryIconFile.value : productIconFile.value;
      if (!file) return null;
      const res = await uploadFile(file, 'product-icon', 'public');
      const fileKey = res?.fileName || res?.data?.fileName;
      if (!fileKey) throw new Error('上传图标失败，未获取到图片地址');
      return fileKey;
    };
    const categoryLoading = ref(false);
    const productLoading = ref(false);
    const detailLoading = ref(false);
    const materialTypeLoading = ref(false);
    const showCategoryModal = ref(false);
    const isCategoryEdit = ref(false);
    const showProductModal = ref(false);
    const isProductEdit = ref(false);
    const showDetailModal = ref(false);
    const showApprovalDetailModal = ref(false);
    const selectedApprovalInstanceId = ref(null);
    const showConfirmModal = ref(false);
    const confirmMessage = ref('');
    const confirmPayload = ref({
      type: '',
      id: null
    });
    const categories = ref([]);
    const products = ref([]);
    const materialTypeGroups = ref([]);
    const materialTypeOptions = ref([]);
    const searchKeyword = ref('');
    const selectedCategory = ref('');
    const selectedStatus = ref('');
    const pageSize = ref(10);
    const pageInfo = reactive({
      current: 1,
      size: 10,
      total: 0,
      pages: 1,
      hasPrevious: false,
      hasNext: false
    });
    const categoryForm = reactive({
      id: null,
      code: '',
      name: '',
      icon: '',
      description: '',
      sort: 1,
      status: 1,
      deptId: null
    });
    const pricingTypes = [{
      label: '固定价',
      value: 'FIXED'
    }, {
      label: '区间价',
      value: 'RANGE'
    }, {
      label: '阶梯价',
      value: 'TIER'
    }, {
      label: '计项价',
      value: 'ITEMIZED'
    }, {
      label: '面议',
      value: 'QUOTE'
    }, {
      label: '订阅价',
      value: 'SUBSCRIPTION'
    }];
    const getMaterialTypeId = type => type?.id ?? type?.materialDefinitionId;
    const getMaterialTypeName = type => type?.name || type?.nameAlias || '未命名';
    const getMaterialTypeCode = type => type?.code || '';
    const categoryName = categoryId => {
      const category = categories.value.find(item => item.id === categoryId);
      return category ? category.name : '-';
    };

    // 详情弹窗相关
    const selectedDetailId = ref(null);
    const openDetailModal = id => {
      selectedDetailId.value = id;
      showDetailModal.value = true;
    };

    // 审批详情弹窗相关
    const openApprovalDetailModal = product => {
      if (!product?.approvalInstanceId) {
        ElMessage.warning('该产品暂无审批实例');
        return;
      }
      selectedApprovalInstanceId.value = product.approvalInstanceId;
      showApprovalDetailModal.value = true;
    };

    // 小程序预览相关
    const showPreviewModal = ref(false);
    const previewProductId = ref(null);
    const previewFormData = ref(null);

    // 列表入口：预览已保存产品（管理端详情接口草稿优先，含待审修改）
    const openProductPreview = productId => {
      previewFormData.value = null;
      previewProductId.value = productId;
      showPreviewModal.value = true;
    };

    // 编辑弹窗入口：预览当前表单内容（含未保存修改），数据形状与预览组件约定一致
    const openFormPreview = () => {
      previewProductId.value = null;
      previewFormData.value = {
        name: productForm.name,
        shortName: productForm.shortName,
        iconUrl: productIconPreview.value || resolveFileUrl(productForm.icon),
        summary: productForm.version.summary,
        detailContent: productForm.version.detailContent,
        serviceScope: productForm.version.serviceScope,
        processSteps: productForm.version.processSteps,
        durationDays: productForm.version.durationDays,
        deliverables: productForm.version.deliverables,
        notices: productForm.version.notices,
        materials: productForm.materials.map(item => ({
          name: item.name,
          isRequired: item.isRequired ? 1 : 0
        })),
        priceModels: productForm.priceModels.map(model => ({
          priceDisplay: model.priceDisplay,
          unit: model.unit
        }))
      };
      showPreviewModal.value = true;
    };
    const syncMaterialInfo = material => {
      const matchedType = materialTypeOptions.value.find(type => getMaterialTypeId(type) === material.materialDefinitionId);
      if (!matchedType) {
        material.name = material.name || '';
        material.code = material.code || '';
        return;
      }
      material.name = getMaterialTypeName(matchedType);
      material.code = getMaterialTypeCode(matchedType);
      if (typeof matchedType.allowMultiple !== 'undefined') {
        material.allowMultiple = Boolean(matchedType.allowMultiple);
      }
    };
    const syncMaterialList = () => {
      productForm.materials.forEach(material => syncMaterialInfo(material));
    };
    const loadMaterialTypes = async () => {
      materialTypeLoading.value = true;
      try {
        const data = await getCustomerMaterialTypes();
        materialTypeGroups.value = (data || []).map(group => ({
          categoryId: group.categoryId,
          categoryName: group.categoryName || group.categoryCode || '未分类',
          sort: group.sort ?? 0,
          definitions: (group.materialDefinitions || []).map(def => ({
            id: def.id,
            code: def.code,
            name: def.name,
            nameAlias: def.nameAlias,
            isRequired: def.isRequired,
            allowMultiple: def.allowMultiple,
            sort: def.sort ?? 0
          }))
        })).sort((a, b) => a.sort - b.sort);
        materialTypeOptions.value = materialTypeGroups.value.flatMap(group => group.definitions);
        syncMaterialList();
      } catch (error) {
        ElMessage.error(error.message || '加载资料类型失败');
      } finally {
        materialTypeLoading.value = false;
      }
    };

    // 编辑产品弹窗：页签切换（每个页签展示一个区块，减少滚动）
    const productFormSections = [{
      key: 'basic',
      label: '基础信息'
    }, {
      key: 'version',
      label: '版本信息'
    }, {
      key: 'materials',
      label: '资料要求'
    }, {
      key: 'pricing',
      label: '价格模型'
    }];
    const productFormScrollRef = ref(null);
    const activeProductSection = ref('basic');
    function switchProductSection(key) {
      activeProductSection.value = key;
      productFormScrollRef.value?.scrollTo({
        top: 0
      });
    }
    function parseProcessSteps(processSteps) {
      // 如果是数组，直接返回
      if (Array.isArray(processSteps)) {
        return processSteps.map((step, index) => ({
          sort: step.sort || index + 1,
          name: step.name || '',
          notes: step.notes || ''
        }));
      }
      // 如果是字符串，尝试解析为 JSON
      if (typeof processSteps === 'string' && processSteps.trim()) {
        try {
          const parsed = JSON.parse(processSteps);
          if (Array.isArray(parsed)) {
            return parsed.map((step, index) => ({
              sort: step.sort || index + 1,
              name: step.name || '',
              notes: step.notes || ''
            }));
          }
        } catch (error) {
          console.error('解析流程步骤 JSON 失败:', error);
        }
      }
      // 默认返回空数组
      return [];
    }
    function createPriceModel(type) {
      const base = {
        pricingType: type,
        currency: 'CNY',
        unit: '次',
        priceDisplay: '',
        configJson: '',
        items: []
      };
      if (type === 'FIXED') {
        base.items = [{
          name: '标准价',
          price: '',
          note: ''
        }];
      } else if (type === 'RANGE') {
        base.items = [{
          name: '区间价',
          priceMin: '',
          priceMax: '',
          note: ''
        }];
      } else if (type === 'TIER') {
        base.items = [{
          name: '阶梯价',
          minQty: '',
          maxQty: '',
          price: '',
          note: ''
        }];
      } else if (type === 'ITEMIZED') {
        base.items = [{
          name: '基础项',
          price: '',
          note: ''
        }];
      } else if (type === 'SUBSCRIPTION') {
        base.items = [{
          name: '首年',
          price: '',
          note: ''
        }, {
          name: '续费',
          price: '',
          note: ''
        }];
      }
      return base;
    }
    const createEmptyProductForm = () => ({
      id: null,
      categoryId: '',
      code: '',
      name: '',
      shortName: '',
      icon: '',
      needApproval: 1,
      needOrderReminder: 0,
      orderReminderPrompt: '',
      version: {
        summary: '',
        detailContent: '',
        serviceScope: '',
        processSteps: [],
        durationDays: '',
        deliverables: '',
        notices: ''
      },
      materials: [],
      priceModels: [createPriceModel('FIXED')]
    });
    const productForm = reactive(createEmptyProductForm());

    // 开关切为「不需要」时隐藏并清空提示语
    const handleNeedOrderReminderChange = val => {
      if (val !== 1) {
        productForm.orderReminderPrompt = '';
      }
    };

    // 编辑弹窗中展示的产品审批/版本元数据（来自详情接口，不属于可编辑表单）
    const productEditMeta = reactive({
      approvalInstanceId: null,
      approvalAction: null,
      hasDraftVersion: false,
      onlineVersionNo: null
    });
    const resetProductEditMeta = () => {
      productEditMeta.approvalInstanceId = null;
      productEditMeta.approvalAction = null;
      productEditMeta.hasDraftVersion = false;
      productEditMeta.onlineVersionNo = null;
    };
    const loadCategories = async () => {
      categoryLoading.value = true;
      try {
        categories.value = await getProductCategories();
      } catch (error) {
        ElMessage.error(error.message || '加载产品类型失败');
      } finally {
        categoryLoading.value = false;
      }
    };
    const loadProducts = async (page = 1) => {
      productLoading.value = true;
      try {
        const data = await getProductPage({
          categoryId: selectedCategory.value || undefined,
          keyword: searchKeyword.value || undefined,
          status: selectedStatus.value === '' ? undefined : Number(selectedStatus.value),
          page,
          size: pageSize.value
        });
        products.value = data.records || [];
        Object.assign(pageInfo, {
          current: data.current || 1,
          size: data.size || pageSize.value,
          total: data.total || 0,
          pages: data.pages || 1,
          hasPrevious: data.hasPrevious,
          hasNext: data.hasNext
        });
      } catch (error) {
        ElMessage.error(error.message || '加载产品列表失败');
      } finally {
        productLoading.value = false;
      }
    };
    const handlePageSizeChange = size => {
      pageSize.value = size;
      pageInfo.size = size;
      loadProducts(1);
    };
    const handleSearch = () => {
      loadProducts(1);
    };
    const handleRefresh = () => {
      loadProducts(pageInfo.current || 1);
    };
    const openCategoryModal = async category => {
      categoryIconFile.value = null;
      if (categoryIconPreview.value) URL.revokeObjectURL(categoryIconPreview.value);
      categoryIconPreview.value = '';
      categoryIconModified.value = false;
      if (category) {
        Object.assign(categoryForm, category);
        categoryDeptSelection.value = category.deptId ? {
          id: category.deptId,
          name: ''
        } : null;
        if (category.deptId) {
          try {
            const dept = await getDept(category.deptId);
            if (dept?.name && categoryDeptSelection.value?.id === category.deptId) {
              categoryDeptSelection.value = {
                id: category.deptId,
                name: dept.name
              };
            }
          } catch (e) {
            console.error('加载执行部门失败', e);
          }
        }
        isCategoryEdit.value = true;
      } else {
        Object.assign(categoryForm, {
          id: null,
          code: '',
          name: '',
          icon: '',
          description: '',
          sort: 1,
          status: 1,
          deptId: null
        });
        categoryDeptSelection.value = null;
        isCategoryEdit.value = false;
      }
      showCategoryModal.value = true;
    };
    const closeCategoryModal = () => {
      showCategoryModal.value = false;
    };
    const submitCategory = async () => {
      if (!categoryForm.code || !categoryForm.name) {
        ElMessage.warning('请填写类型编码和名称');
        return;
      }
      try {
        // 如果有待上传的图标文件，先上传
        const iconKey = await uploadIconIfNeeded('category');
        if (iconKey) categoryForm.icon = iconKey;
        const payload = {
          ...categoryForm
        };
        if (isCategoryEdit.value && !categoryIconModified.value) {
          delete payload.icon;
        }
        if (isCategoryEdit.value) {
          await updateProductCategory(payload);
          ElMessage.success('类型更新成功');
        } else {
          await createProductCategory(payload);
          ElMessage.success('类型创建成功');
        }
        categoryIconFile.value = null;
        if (categoryIconPreview.value) {
          URL.revokeObjectURL(categoryIconPreview.value);
          categoryIconPreview.value = '';
        }
        showCategoryModal.value = false;
        await loadCategories();
      } catch (error) {
        ElMessage.error(error.message || '保存类型失败');
      }
    };
    const openProductModal = async id => {
      if (id) {
        // 在途审批期间禁止编辑，避免产生与审批内容不一致的草稿
        const target = products.value.find(item => item.id === id);
        if (target?.approvalInstanceId) {
          ElMessage.warning('该产品存在在途审批，请先在审批中心完成或撤销审批后再编辑');
          return;
        }
      }
      productIconFile.value = null;
      if (productIconPreview.value) URL.revokeObjectURL(productIconPreview.value);
      productIconPreview.value = '';
      productIconModified.value = false;
      if (!materialTypeOptions.value.length) {
        await loadMaterialTypes();
      }
      Object.assign(productForm, createEmptyProductForm());
      resetProductEditMeta();
      if (id) {
        isProductEdit.value = true;
        await loadProductDetail(id, true);
      } else {
        isProductEdit.value = false;
      }
      showProductModal.value = true;
    };
    const closeProductModal = () => {
      showProductModal.value = false;
    };
    const loadProductDetail = async (id, forEdit = false) => {
      detailLoading.value = true;
      try {
        const data = await getProductDetail(id);
        if (forEdit) {
          // 审批/版本元数据：仅用于弹窗提示，不参与表单提交
          productEditMeta.approvalInstanceId = data.approvalInstanceId ?? null;
          productEditMeta.approvalAction = data.approvalAction ?? null;
          productEditMeta.hasDraftVersion = !!data.hasDraftVersion;
          productEditMeta.onlineVersionNo = data.onlineVersionNo ?? null;
          Object.assign(productForm, {
            id: data.id,
            categoryId: data.categoryId,
            code: data.code,
            name: data.name,
            shortName: data.shortName || '',
            icon: data.icon || '',
            needApproval: data.needApproval ?? 1,
            needOrderReminder: data.needOrderReminder ?? 0,
            orderReminderPrompt: data.orderReminderPrompt ?? '',
            version: {
              summary: data.summary || '',
              detailContent: data.detailContent || '',
              serviceScope: data.serviceScope || '',
              processSteps: parseProcessSteps(data.processSteps),
              durationDays: data.durationDays || '',
              deliverables: data.deliverables || '',
              notices: data.notices || ''
            },
            materials: (data.materials || []).map(item => ({
              materialDefinitionId: item.materialDefinitionId,
              name: item.name || '',
              code: item.code || '',
              isRequired: item.isRequired === 1,
              allowMultiple: item.allowMultiple === 1
            })),
            priceModels: (data.priceModels || []).map(model => ({
              pricingType: model.pricingType,
              currency: model.currency || 'CNY',
              unit: model.unit || '',
              priceDisplay: model.priceDisplay || '',
              configJson: model.configJson || '',
              items: (model.items || []).map(item => ({
                name: item.name || '',
                minQty: item.minQty ?? '',
                maxQty: item.maxQty ?? '',
                price: item.price ?? '',
                priceMin: item.priceMin ?? '',
                priceMax: item.priceMax ?? '',
                note: item.note || ''
              }))
            }))
          });
          syncMaterialList();
        }
      } catch (error) {
        ElMessage.error(error.message || '加载产品详情失败');
      } finally {
        detailLoading.value = false;
      }
    };
    const addMaterial = async () => {
      if (!materialTypeOptions.value.length) {
        await loadMaterialTypes();
      }
      productForm.materials.push({
        materialDefinitionId: '',
        name: '',
        code: '',
        isRequired: true,
        allowMultiple: false
      });
    };
    const removeMaterial = index => {
      productForm.materials.splice(index, 1);
    };
    const addProcessStep = () => {
      const newSort = productForm.version.processSteps.length + 1;
      productForm.version.processSteps.push({
        sort: newSort,
        name: '',
        notes: ''
      });
    };
    const removeProcessStep = index => {
      productForm.version.processSteps.splice(index, 1);
      // 重新排序
      productForm.version.processSteps.forEach((step, idx) => {
        step.sort = idx + 1;
      });
    };
    const addPriceModel = () => {
      productForm.priceModels.push(createPriceModel('FIXED'));
    };
    const removePriceModel = index => {
      productForm.priceModels.splice(index, 1);
    };
    const resetPriceItems = model => {
      const newModel = createPriceModel(model.pricingType);
      model.currency = newModel.currency;
      model.unit = newModel.unit;
      model.priceDisplay = '';
      model.items = newModel.items;
    };
    const addPriceItem = model => {
      const template = createPriceModel(model.pricingType).items[0];
      model.items.push({
        ...template
      });
    };
    const removePriceItem = (model, index) => {
      model.items.splice(index, 1);
    };
    const submitProduct = async () => {
      if (!productForm.name || !productForm.code || !productForm.categoryId) {
        activeProductSection.value = 'basic';
        ElMessage.warning('请填写产品名称、编码和类型');
        return;
      }
      const missingMaterial = productForm.materials.find(item => !item.materialDefinitionId);
      if (missingMaterial) {
        activeProductSection.value = 'materials';
        ElMessage.warning('请选择资料类型');
        return;
      }
      const missingStepName = productForm.version.processSteps.find(step => !step.name || !step.name.trim());
      if (missingStepName) {
        activeProductSection.value = 'version';
        ElMessage.warning('请填写所有流程步骤的名称');
        return;
      }
      if (productForm.needOrderReminder === 1 && !(productForm.orderReminderPrompt || '').trim()) {
        activeProductSection.value = 'basic';
        ElMessage.warning('请填写提醒提示语');
        return;
      }

      // 将流程步骤转换为 JSON 字符串
      const processStepsArray = productForm.version.processSteps.map((step, index) => ({
        sort: step.sort || index + 1,
        name: step.name,
        notes: step.notes || ''
      }));
      const processStepsJson = processStepsArray.length > 0 ? JSON.stringify(processStepsArray) : '';
      try {
        // 如果有待上传的图标文件，先上传
        const iconKey = await uploadIconIfNeeded('product');
        if (iconKey) productForm.icon = iconKey;
        const payload = {
          id: productForm.id || undefined,
          categoryId: Number(productForm.categoryId),
          code: productForm.code,
          name: productForm.name,
          shortName: productForm.shortName,
          ...(!isProductEdit.value || productIconModified.value ? {
            icon: productForm.icon || undefined
          } : {}),
          needApproval: Number(productForm.needApproval),
          needOrderReminder: Number(productForm.needOrderReminder),
          orderReminderPrompt: productForm.needOrderReminder === 1 ? productForm.orderReminderPrompt.trim() : null,
          version: {
            ...productForm.version,
            durationDays: productForm.version.durationDays ? Number(productForm.version.durationDays) : undefined,
            processSteps: processStepsJson
          },
          materials: productForm.materials.map((item, index) => ({
            materialDefinitionId: Number(item.materialDefinitionId),
            isRequired: item.isRequired ? 1 : 0,
            sort: index + 1
          })),
          priceModels: productForm.priceModels.map((model, index) => ({
            pricingType: model.pricingType,
            currency: model.currency || 'CNY',
            unit: model.unit || '',
            priceDisplay: model.priceDisplay || '',
            configJson: model.configJson || null,
            sort: index + 1,
            items: (model.items || []).map((item, itemIndex) => ({
              name: item.name || '',
              minQty: item.minQty !== '' ? Number(item.minQty) : undefined,
              maxQty: item.maxQty !== '' ? Number(item.maxQty) : undefined,
              price: item.price !== '' ? Number(item.price) : undefined,
              priceMin: item.priceMin !== '' ? Number(item.priceMin) : undefined,
              priceMax: item.priceMax !== '' ? Number(item.priceMax) : undefined,
              note: item.note || '',
              sort: itemIndex + 1
            }))
          }))
        };
        if (isProductEdit.value) {
          const updated = await updateProduct(payload);
          // 后端按字段比对决定生效方式：涉及小程序展示内容的修改保存为待审草稿，其余直接生效
          ElMessage.success(updated?.hasDraftVersion ? '产品已更新，展示内容修改已保存为待审草稿，提交发布新版审批通过后生效' : '产品已更新，修改内容已直接生效');
        } else {
          await createProduct(payload);
          ElMessage.success('产品创建成功，当前未上架，可提交上架审批');
        }
        productIconFile.value = null;
        if (productIconPreview.value) {
          URL.revokeObjectURL(productIconPreview.value);
          productIconPreview.value = '';
        }
        showProductModal.value = false;
        await loadProducts(1);
      } catch (error) {
        ElMessage.error(error.message || '保存产品失败');
      }
    };
    const toggleHot = async product => {
      const newHot = product.isHot === 1 ? 0 : 1;
      try {
        await setProductHot({
          id: product.id,
          isHot: newHot
        });
        product.isHot = newHot;
        ElMessage.success(newHot === 1 ? '已设为热门' : '已取消热门');
      } catch (error) {
        ElMessage.error(error.message || '设置热门状态失败');
      }
    };

    // 提交产品上架/下架审批
    // 已上架且存在待审草稿时，上架审批语义为"发布新版"：审批通过后草稿版本对外生效
    const isRepublish = product => product.status === 1 && !!product.hasDraftVersion;
    const canSubmitPublishApproval = product => product.status === 0 || isRepublish(product);
    const publishApprovalLabel = product => isRepublish(product) ? '提交发布新版审批' : '提交上架审批';
    const handleSubmitApproval = async (product, action) => {
      const isPublish = action === 'publish';
      const republish = isPublish && isRepublish(product);
      try {
        await ElMessageBox.confirm(isPublish ? republish ? `确认提交产品「${product.name}」的发布新版审批？审批通过后本次修改内容将对外生效。` : `确认提交产品「${product.name}」的上架审批？审批通过后产品才会对外上架。` : `确认提交产品「${product.name}」的下架审批？审批通过后产品将停止对外展示。`, isPublish ? publishApprovalLabel(product) : '提交下架审批', {
          confirmButtonText: '提交',
          cancelButtonText: '取消',
          type: 'warning'
        });
        if (isPublish) {
          await submitPublishApproval(product.id);
          ElMessage.success(republish ? '发布新版审批已提交，请等待审批处理' : '上架审批已提交，请等待审批处理');
        } else {
          await submitUnpublishApproval(product.id);
          ElMessage.success('下架审批已提交，请等待审批处理');
        }
        await loadProducts(pageInfo.current);
      } catch (error) {
        if (error === 'cancel' || error?.toString?.().includes('cancel')) return;
        ElMessage.error(error.message || '提交审批失败');
      }
    };
    const confirmDelete = (type, data) => {
      if (type === 'product' && data.approvalInstanceId) {
        ElMessage.warning('该产品存在在途审批，不能删除，请先完成或撤销审批');
        return;
      }
      confirmPayload.value = {
        type,
        id: data.id
      };
      confirmMessage.value = type === 'category' ? `确认删除类型「${data.name}」？若类型下存在产品将无法删除。` : `确认删除产品「${data.name}」？`;
      showConfirmModal.value = true;
    };
    const closeConfirmModal = () => {
      showConfirmModal.value = false;
    };
    const confirmDeleteAction = async () => {
      const {
        type,
        id
      } = confirmPayload.value;
      try {
        if (type === 'category') {
          await deleteProductCategory(id);
          ElMessage.success('类型已删除');
          await loadCategories();
        } else if (type === 'product') {
          await deleteProduct(id);
          ElMessage.success('产品已删除');
          await loadProducts(pageInfo.current);
        }
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        showConfirmModal.value = false;
      }
    };
    const resetFilters = () => {
      searchKeyword.value = '';
      selectedCategory.value = '';
      selectedStatus.value = '';
      loadProducts(1);
    };
    const applyCategoryFilter = async categoryId => {
      const nextValue = String(categoryId);
      selectedCategory.value = selectedCategory.value === nextValue ? '' : nextValue;
      await loadProducts(1);
    };
    onMounted(async () => {
      await loadCategories();
      await loadMaterialTypes();
      await loadProducts(1);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_option_group = _resolveComponent("el-option-group");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "产品管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, " 产品目录管理、产品配置与展示、价格体系配置、资料要求配置。产品创建后默认未上架，编辑生成待审草稿版本，提交审批通过后才会对外生效。 ")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(ProductCategorySidebar, {
          categories: categories.value,
          loading: categoryLoading.value,
          "selected-category-id": selectedCategory.value,
          title: "产品类型管理",
          description: "删除前会校验，类型下存在产品将无法删除。",
          onAdd: _cache[0] || (_cache[0] = $event => openCategoryModal()),
          onEdit: openCategoryModal,
          onDelete: _cache[1] || (_cache[1] = category => confirmDelete('category', category)),
          onSelect: applyCategoryFilter
        }, null, 8, ["categories", "loading", "selected-category-id"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": productLoading.value,
          onRefresh: handleRefresh
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[5] || (_cache[5] = $event => openProductModal()),
            class: "btn-primary"
          }, [...(_cache[34] || (_cache[34] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新建产品 ", -1)]))])), [[_directive_permission, 'product:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: productLoading.value,
            onClick: handleSearch
          }, " 搜索 ", 8, _hoisted_6), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: productLoading.value,
            onClick: resetFilters
          }, " 重置 ", 8, _hoisted_7)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索产品名称或编码",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[33] || (_cache[33] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: selectedCategory.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectedCategory.value = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, category => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: category.id,
                label: category.name,
                value: category.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: selectedStatus.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectedStatus.value = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "上架",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "下架",
              value: "0"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("table", _hoisted_10, [_cache[46] || (_cache[46] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "产品名称"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "摘要"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "展示价"), _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "周期(天)"), _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "热门"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_11, [productLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[35] || (_cache[35] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "w-10 h-10 bg-slate-200 rounded-lg"
          }), _createElementVNode("div", null, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded mb-1"
          }), _createElementVNode("div", {
            class: "h-3 w-24 bg-slate-200 rounded"
          })])])], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-4 w-12 bg-slate-200 rounded mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-14 bg-slate-200 rounded-full mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-10 bg-slate-200 rounded-full mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "flex items-center justify-center gap-2"
          }, [_createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          })])], -1)]))]);
        }), 64)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, product => {
          return _openBlock(), _createElementBlock("tr", {
            key: product.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [product.icon ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: resolveFileUrl(product.icon),
            class: "h-full w-full object-cover",
            alt: ""
          }, null, 8, _hoisted_15)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          })], -1)]))]))]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_17, _toDisplayString(product.name), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(product.shortName || product.code), 1)])])]), _createElementVNode("td", _hoisted_19, [_createElementVNode("div", {
            class: "data-table-cell-clamp",
            title: product.summary || ''
          }, _toDisplayString(product.summary || '-'), 9, _hoisted_20)]), _createElementVNode("td", _hoisted_21, _toDisplayString(product.priceDisplay || '-'), 1), _createElementVNode("td", _hoisted_22, _toDisplayString(product.durationDays ?? '-'), 1), _createElementVNode("td", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', product.status === 1 ? 'status-badge is-success' : 'status-badge is-neutral'])
          }, _toDisplayString(product.status === 1 ? '上架' : '下架'), 3), product.approvalInstanceId ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "status-badge is-warning",
            title: product.approvalAction === 'UNPUBLISH' ? '下架审批进行中' : '上架审批进行中'
          }, _toDisplayString(product.approvalAction === 'UNPUBLISH' ? '下架审批中' : '上架审批中'), 9, _hoisted_25)) : product.hasDraftVersion ? (_openBlock(), _createElementBlock("span", _hoisted_26, " 待审草稿 ")) : _createCommentVNode("", true), product.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "table-action-button is-purple cursor-pointer",
            title: "查看审批详情",
            "aria-label": "查看审批详情",
            onClick: _withModifiers($event => openApprovalDetailModal(product), ["stop"])
          }, [...(_cache[37] || (_cache[37] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1)]))], 8, _hoisted_27)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_28, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => toggleHot(product),
            class: _normalizeClass(["status-badge inline-flex items-center gap-1 transition-colors", product.isHot === 1 ? 'bg-orange-100 text-orange-600 hover:bg-orange-200' : 'bg-slate-100 text-slate-500 hover:bg-slate-200']),
            title: product.isHot === 1 ? '取消热门' : '设为热门'
          }, [(_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["h-3.5 w-3.5", product.isHot === 1 ? 'fill-orange-500' : 'fill-none stroke-current']),
            viewBox: "0 0 24 24"
          }, [...(_cache[38] || (_cache[38] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
          }, null, -1), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
          }, null, -1)]))], 2)), _createTextVNode(" " + _toDisplayString(product.isHot === 1 ? '热门' : '-'), 1)], 10, _hoisted_29)), [[_directive_permission, 'product:edit']])]), _createElementVNode("td", _hoisted_30, _toDisplayString(categoryName(product.categoryId)), 1), _createElementVNode("td", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("button", {
            onClick: $event => openDetailModal(product.id),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_33), _createElementVNode("button", {
            onClick: $event => openProductPreview(product.id),
            class: "table-action-button is-teal",
            title: "小程序预览（含待审草稿内容）",
            "aria-label": "小程序预览"
          }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })], -1)]))], 8, _hoisted_34), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openProductModal(product.id),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_35)), [[_directive_permission, 'product:edit']]), canSubmitPublishApproval(product) ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleSubmitApproval(product, 'publish'),
            class: "table-action-button is-primary",
            disabled: !!product.approvalInstanceId,
            title: product.approvalInstanceId ? '存在在途审批，不能重复提交' : publishApprovalLabel(product),
            "aria-label": publishApprovalLabel(product)
          }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 10l7-7m0 0l7 7m-7-7v18"
          })], -1)]))], 8, _hoisted_36)), [[_directive_permission, 'product:publish']]) : _createCommentVNode("", true), product.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => handleSubmitApproval(product, 'unpublish'),
            class: "table-action-button is-warning",
            disabled: !!product.approvalInstanceId,
            title: product.approvalInstanceId ? '存在在途审批，不能重复提交' : '提交下架审批',
            "aria-label": "提交下架审批"
          }, [...(_cache[43] || (_cache[43] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 14l-7 7m0 0l-7-7m7 7V3"
          })], -1)]))], 8, _hoisted_37)), [[_directive_permission, 'product:unpublish']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => confirmDelete('product', product),
            class: "table-action-button is-danger",
            disabled: !!product.approvalInstanceId,
            title: product.approvalInstanceId ? '存在在途审批，不能删除' : '删除',
            "aria-label": "删除"
          }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_38)), [[_directive_permission, 'product:delete']])])])]);
        }), 128)), !productLoading.value && !products.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [...(_cache[45] || (_cache[45] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty text-sm text-slate-500"
        }, "暂无产品数据", -1)]))])) : _createCommentVNode("", true)])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pageInfo,
          size: pageSize.value,
          "page-sizes": [10, 20, 50],
          onPageChange: loadProducts,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "size"])])])]), _createVNode(AppModal, {
          visible: showCategoryModal.value,
          size: "4xl",
          onClose: closeCategoryModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createElementVNode("h3", _hoisted_41, _toDisplayString(isCategoryEdit.value ? '编辑产品类型' : '新增产品类型'), 1), _createElementVNode("button", {
            onClick: closeCategoryModal,
            class: "rounded-full p-1 text-slate-400 hover:text-slate-600"
          }, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, [_cache[48] || (_cache[48] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("类型编码 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => categoryForm.code = $event),
            class: "form-input mt-2 w-full",
            placeholder: "例如 FIN_TAX"
          }, null, 512), [[_vModelText, categoryForm.code]])]), _createElementVNode("div", null, [_cache[49] || (_cache[49] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("类型名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => categoryForm.name = $event),
            class: "form-input mt-2 w-full",
            placeholder: "例如 财务税务"
          }, null, 512), [[_vModelText, categoryForm.name]])]), _createElementVNode("div", null, [_cache[50] || (_cache[50] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "执行部门", -1)), _createVNode(DeptSelector, {
            modelValue: categoryDeptSelection.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => categoryDeptSelection.value = $event),
            multiple: false,
            placeholder: "请选择执行部门",
            class: "mt-2"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[54] || (_cache[54] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "图标", -1)), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [categoryIconPreview.value || categoryForm.icon ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: categoryIconPreview.value || resolveFileUrl(categoryForm.icon),
            class: "h-full w-full object-cover",
            alt: "类型图标"
          }, null, 8, _hoisted_46)) : (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)]))]))]), _createElementVNode("div", _hoisted_48, [_createElementVNode("label", _hoisted_49, [_cache[52] || (_cache[52] = _createTextVNode(" 选择图标 ", -1)), _createElementVNode("input", {
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: _cache[9] || (_cache[9] = $event => handleIconSelect($event, 'category'))
          }, null, 32)]), categoryIconPreview.value || categoryForm.icon ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[10] || (_cache[10] = $event => clearIconSelect('category')),
            class: "text-left text-xs text-red-500 hover:text-red-600"
          }, " 移除 ")) : _createCommentVNode("", true), _cache[53] || (_cache[53] = _createElementVNode("span", {
            class: "text-xs text-slate-400"
          }, "支持 JPG、PNG，≤5MB", -1))])])]), _createElementVNode("div", null, [_cache[55] || (_cache[55] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "描述", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => categoryForm.description = $event),
            rows: "3",
            class: "form-textarea mt-2",
            placeholder: "类型说明"
          }, null, 512), [[_vModelText, categoryForm.description]])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", null, [_cache[56] || (_cache[56] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "排序", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => categoryForm.sort = $event),
            type: "number",
            class: "form-input mt-2 w-full"
          }, null, 512), [[_vModelText, categoryForm.sort, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[57] || (_cache[57] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "状态", -1)), _createVNode(_component_el_select, {
            modelValue: categoryForm.status,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => categoryForm.status = $event),
            class: "form-select mt-2 w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "启用",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])])])])]), _createElementVNode("div", {
            class: "flex justify-end gap-2 border-t border-slate-200 px-6 py-4 shrink-0"
          }, [_createElementVNode("button", {
            onClick: closeCategoryModal,
            class: "rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700"
          }, "取消"), _createElementVNode("button", {
            onClick: submitCategory,
            class: "rounded-lg bg-primary-700 px-4 py-2 text-sm text-white hover:bg-primary-800"
          }, "保存")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showProductModal.value,
          size: "5xl",
          onClose: closeProductModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_52, _toDisplayString(isProductEdit.value ? '编辑产品' : '新建产品'), 1), _createElementVNode("p", _hoisted_53, _toDisplayString(isProductEdit.value ? '涉及小程序展示内容（名称、图标、分类、详情、资料、价格等）的修改将保存为待审草稿，提交发布新版审批通过后生效；其余配置修改直接生效。' : '创建后默认未上架，需提交上架审批通过后才对外可见。'), 1), isProductEdit.value && productEditMeta.onlineVersionNo ? (_openBlock(), _createElementBlock("p", _hoisted_54, " 线上版本 v" + _toDisplayString(productEditMeta.onlineVersionNo) + " 仍在对外展示，本次修改审批通过后生效。 ", 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
            onClick: closeProductModal,
            class: "rounded-full p-1 text-slate-400 hover:text-slate-600"
          }, [...(_cache[58] || (_cache[58] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_55, [_createElementVNode("nav", _hoisted_56, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(productFormSections, section => {
            return _createElementVNode("button", {
              key: section.key,
              type: "button",
              class: _normalizeClass(["rounded-lg border-l-2 px-2.5 py-2 text-left text-xs transition-colors", activeProductSection.value === section.key ? 'border-primary-600 bg-primary-50 font-medium text-primary-700' : 'border-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-700']),
              onClick: $event => switchProductSection(section.key)
            }, _toDisplayString(section.label), 11, _hoisted_57);
          }), 64))]), _createElementVNode("div", {
            ref_key: "productFormScrollRef",
            ref: productFormScrollRef,
            class: "min-w-0 flex-1 overflow-y-auto"
          }, [_createElementVNode("div", _hoisted_58, [_withDirectives(_createElementVNode("section", _hoisted_59, [_cache[72] || (_cache[72] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "基础信息", -1)), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", null, [_cache[59] || (_cache[59] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, [_createTextVNode("产品名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => productForm.name = $event),
            class: "form-input mt-2 w-full",
            placeholder: "产品名称"
          }, null, 512), [[_vModelText, productForm.name]])]), _createElementVNode("div", null, [_cache[63] || (_cache[63] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "产品图标", -1)), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [productIconPreview.value || productForm.icon ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: productIconPreview.value || resolveFileUrl(productForm.icon),
            class: "h-full w-full object-cover",
            alt: "产品图标"
          }, null, 8, _hoisted_63)) : (_openBlock(), _createElementBlock("div", _hoisted_64, [...(_cache[60] || (_cache[60] = [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)]))]))]), _createElementVNode("div", _hoisted_65, [_createElementVNode("label", _hoisted_66, [_cache[61] || (_cache[61] = _createTextVNode(" 选择图标 ", -1)), _createElementVNode("input", {
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: _cache[15] || (_cache[15] = $event => handleIconSelect($event, 'product'))
          }, null, 32)]), productIconPreview.value || productForm.icon ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[16] || (_cache[16] = $event => clearIconSelect('product')),
            class: "text-left text-xs text-red-500 hover:text-red-600"
          }, " 移除 ")) : _createCommentVNode("", true), _cache[62] || (_cache[62] = _createElementVNode("span", {
            class: "text-xs text-slate-400"
          }, "支持 JPG、PNG，≤5MB", -1))])])]), _createElementVNode("div", null, [_cache[64] || (_cache[64] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, [_createTextVNode("产品编码 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => productForm.code = $event),
            class: "form-input mt-2 w-full",
            placeholder: "产品编码"
          }, null, 512), [[_vModelText, productForm.code]])]), _createElementVNode("div", null, [_cache[65] || (_cache[65] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "短名", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => productForm.shortName = $event),
            class: "form-input mt-2 w-full",
            placeholder: "短名"
          }, null, 512), [[_vModelText, productForm.shortName]])]), _createElementVNode("div", null, [_cache[66] || (_cache[66] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, [_createTextVNode("产品类型 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: productForm.categoryId,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => productForm.categoryId = $event),
            placeholder: "请选择",
            class: "form-select mt-2 w-full"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, category => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: category.id,
                label: category.name,
                value: category.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[67] || (_cache[67] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "审批关联方案", -1)), _createVNode(_component_el_select, {
            modelValue: productForm.needApproval,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => productForm.needApproval = $event),
            class: "form-select mt-2 w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "需要审批",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "无需审批",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[68] || (_cache[68] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "单独设置服务提醒", -1)), _createVNode(_component_el_select, {
            modelValue: productForm.needOrderReminder,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => productForm.needOrderReminder = $event),
            class: "form-select mt-2 w-full",
            onChange: handleNeedOrderReminderChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "需要",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "不需要",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"]), _cache[69] || (_cache[69] = _createElementVNode("p", {
            class: "mt-1 text-xs text-slate-500"
          }, "开启后，创建方案选择该服务产品时必须设置服务提醒", -1))]), productForm.needOrderReminder === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_cache[70] || (_cache[70] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, [_createTextVNode("提醒提示语 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => productForm.orderReminderPrompt = $event),
            class: "form-input mt-2 w-full",
            maxlength: "10",
            placeholder: "如：是否贷款户"
          }, null, 512), [[_vModelText, productForm.orderReminderPrompt]]), _cache[71] || (_cache[71] = _createElementVNode("p", {
            class: "mt-1 text-xs text-slate-500"
          }, "创建订单时将以此文案向用户确认是否需要服务提醒", -1))])) : _createCommentVNode("", true)])], 512), [[_vShow, activeProductSection.value === 'basic']]), _withDirectives(_createElementVNode("section", _hoisted_68, [_cache[86] || (_cache[86] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "版本信息", -1)), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", null, [_cache[73] || (_cache[73] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "摘要", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => productForm.version.summary = $event),
            class: "form-input mt-2 w-full",
            placeholder: "摘要"
          }, null, 512), [[_vModelText, productForm.version.summary]])]), _createElementVNode("div", null, [_cache[74] || (_cache[74] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "服务范围", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => productForm.version.serviceScope = $event),
            class: "form-input mt-2 w-full",
            placeholder: "适用对象/范围"
          }, null, 512), [[_vModelText, productForm.version.serviceScope]])]), _createElementVNode("div", null, [_createElementVNode("div", {
            class: "flex items-center justify-between"
          }, [_cache[76] || (_cache[76] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "流程步骤", -1)), _createElementVNode("button", {
            type: "button",
            onClick: addProcessStep,
            class: "flex items-center gap-1.5 rounded-lg bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-100"
          }, [...(_cache[75] || (_cache[75] = [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 添加步骤 ", -1)]))])]), _createElementVNode("div", _hoisted_70, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productForm.version.processSteps, (step, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "group relative rounded-xl border border-slate-200 bg-gradient-to-br from-white to-slate-50/50 p-4 shadow-sm transition-all hover:shadow-md"
            }, [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, _toDisplayString(index + 1), 1), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", null, [_cache[77] || (_cache[77] = _createElementVNode("label", {
              class: "text-xs font-medium text-slate-600"
            }, [_createTextVNode("步骤名称 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => step.name = $event,
              class: "form-input mt-1.5 w-full",
              placeholder: "例如：需求确认"
            }, null, 8, _hoisted_74), [[_vModelText, step.name]])]), _createElementVNode("div", null, [_cache[78] || (_cache[78] = _createElementVNode("label", {
              class: "text-xs font-medium text-slate-600"
            }, "注意事项", -1)), _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": $event => step.notes = $event,
              rows: "2",
              class: "form-textarea mt-1.5 w-full",
              placeholder: "该步骤的注意事项说明"
            }, null, 8, _hoisted_75), [[_vModelText, step.notes]])])]), _createElementVNode("button", {
              type: "button",
              onClick: $event => removeProcessStep(index),
              class: "shrink-0 rounded-lg p-1.5 text-slate-400 opacity-0 transition-all hover:bg-red-50 hover:text-red-600 group-hover:opacity-100",
              title: "移除步骤"
            }, [...(_cache[79] || (_cache[79] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            })], -1)]))], 8, _hoisted_76)])]);
          }), 128)), !productForm.version.processSteps || !productForm.version.processSteps.length ? (_openBlock(), _createElementBlock("div", _hoisted_77, [...(_cache[80] || (_cache[80] = [_createElementVNode("div", {
            class: "flex h-12 w-12 items-center justify-center rounded-full bg-slate-100"
          }, [_createElementVNode("svg", {
            class: "h-6 w-6 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })])], -1), _createElementVNode("p", {
            class: "empty-state-title"
          }, "暂无流程步骤", -1), _createElementVNode("p", {
            class: "empty-state-desc"
          }, "点击上方\"添加步骤\"按钮开始添加", -1)]))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", null, [_cache[81] || (_cache[81] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "周期(天)", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => productForm.version.durationDays = $event),
            type: "number",
            class: "form-input mt-2 w-full"
          }, null, 512), [[_vModelText, productForm.version.durationDays, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[82] || (_cache[82] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "交付物", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => productForm.version.deliverables = $event),
            class: "form-input mt-2 w-full",
            placeholder: "交付物"
          }, null, 512), [[_vModelText, productForm.version.deliverables]])])]), _createElementVNode("div", null, [_cache[83] || (_cache[83] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "注意事项", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => productForm.version.notices = $event),
            class: "form-input mt-2 w-full",
            placeholder: "注意事项"
          }, null, 512), [[_vModelText, productForm.version.notices]])]), _createElementVNode("div", null, [_cache[84] || (_cache[84] = _createElementVNode("label", {
            class: "text-sm text-slate-700"
          }, "详情介绍", -1)), _createVNode(RichTextField, {
            modelValue: productForm.version.detailContent,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => productForm.version.detailContent = $event),
            "upload-module": "product",
            title: "编辑详情介绍",
            class: "mt-2"
          }, null, 8, ["modelValue"]), _cache[85] || (_cache[85] = _createElementVNode("p", {
            class: "mt-2 text-xs text-slate-500"
          }, "支持富文本格式，保存后将作为产品详情介绍展示。", -1))])])], 512), [[_vShow, activeProductSection.value === 'version']]), _withDirectives(_createElementVNode("section", _hoisted_79, [_createElementVNode("div", {
            class: "flex items-center justify-between"
          }, [_cache[87] || (_cache[87] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "资料要求", -1)), _createElementVNode("button", {
            type: "button",
            onClick: addMaterial,
            class: "rounded-lg border border-slate-200 px-3 py-1 text-xs text-slate-700 hover:bg-slate-50"
          }, "新增资料")]), _cache[91] || (_cache[91] = _createElementVNode("p", {
            class: "mt-2 text-xs text-slate-500"
          }, "资料类型从资料管理中获取，可配置必填。", -1)), _createElementVNode("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productForm.materials, (material, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "grid grid-cols-1 gap-3 rounded-lg border border-slate-200 bg-slate-50 p-3 lg:grid-cols-6"
            }, [_createElementVNode("div", _hoisted_81, [_cache[88] || (_cache[88] = _createElementVNode("label", {
              class: "text-xs text-slate-500"
            }, "资料类型", -1)), _createVNode(_component_el_select, {
              modelValue: material.materialDefinitionId,
              "onUpdate:modelValue": $event => material.materialDefinitionId = $event,
              onChange: $event => syncMaterialInfo(material),
              disabled: materialTypeLoading.value,
              placeholder: "请选择资料类型",
              class: "form-select form-control-sm mt-1 w-full"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(materialTypeGroups.value, group => {
                return _openBlock(), _createBlock(_component_el_option_group, {
                  key: group.categoryId,
                  label: group.categoryName
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.definitions, type => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: getMaterialTypeId(type),
                      label: getMaterialTypeName(type),
                      value: getMaterialTypeId(type)
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])]), _createElementVNode("div", _hoisted_82, [_cache[89] || (_cache[89] = _createElementVNode("label", {
              class: "text-xs text-slate-500"
            }, "资料编码", -1)), _createElementVNode("div", _hoisted_83, _toDisplayString(material.code || '-'), 1)]), _createElementVNode("div", _hoisted_84, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => material.isRequired = $event,
              type: "checkbox",
              class: "form-check"
            }, null, 8, _hoisted_85), [[_vModelCheckbox, material.isRequired]]), _cache[90] || (_cache[90] = _createElementVNode("span", {
              class: "text-xs text-slate-600"
            }, "必填", -1))]), _createElementVNode("div", _hoisted_86, [_createElementVNode("span", _hoisted_87, _toDisplayString(material.allowMultiple ? '可多份' : '单份'), 1)]), _createElementVNode("div", _hoisted_88, [_createElementVNode("button", {
              onClick: $event => removeMaterial(index),
              class: "text-xs text-red-500 hover:text-red-600"
            }, "移除", 8, _hoisted_89)])]);
          }), 128)), !productForm.materials.length ? (_openBlock(), _createElementBlock("div", _hoisted_90, " 暂无资料要求 ")) : _createCommentVNode("", true)])], 512), [[_vShow, activeProductSection.value === 'materials']]), _withDirectives(_createElementVNode("section", _hoisted_91, [_createElementVNode("div", {
            class: "flex items-center justify-between"
          }, [_cache[92] || (_cache[92] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "价格模型", -1)), _createElementVNode("button", {
            type: "button",
            onClick: addPriceModel,
            class: "rounded-lg border border-slate-200 px-3 py-1 text-xs text-slate-700 hover:bg-slate-50"
          }, "新增模型")]), _createElementVNode("div", _hoisted_92, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productForm.priceModels, (model, modelIndex) => {
            return _openBlock(), _createElementBlock("div", {
              key: modelIndex,
              class: "rounded-lg border border-slate-200 bg-slate-50 p-4"
            }, [_createElementVNode("div", _hoisted_93, [_createElementVNode("div", null, [_cache[93] || (_cache[93] = _createElementVNode("label", {
              class: "text-xs text-slate-500"
            }, "定价类型", -1)), _createVNode(_component_el_select, {
              modelValue: model.pricingType,
              "onUpdate:modelValue": $event => model.pricingType = $event,
              onChange: $event => resetPriceItems(model),
              class: "form-select form-control-sm mt-1 w-full"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(pricingTypes, type => {
                return _createVNode(_component_el_option, {
                  key: type.value,
                  label: type.label,
                  value: type.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]), _createElementVNode("div", null, [_cache[94] || (_cache[94] = _createElementVNode("label", {
              class: "text-xs text-slate-500"
            }, "币种", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => model.currency = $event,
              class: "form-input form-control-sm mt-1 w-full",
              placeholder: "CNY"
            }, null, 8, _hoisted_94), [[_vModelText, model.currency]])]), _createElementVNode("div", null, [_cache[95] || (_cache[95] = _createElementVNode("label", {
              class: "text-xs text-slate-500"
            }, "单位", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => model.unit = $event,
              class: "form-input form-control-sm mt-1 w-full",
              placeholder: "次/年/人"
            }, null, 8, _hoisted_95), [[_vModelText, model.unit]])]), _createElementVNode("div", null, [_cache[96] || (_cache[96] = _createElementVNode("label", {
              class: "text-xs text-slate-500"
            }, "展示价", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => model.priceDisplay = $event,
              class: "form-input form-control-sm mt-1 w-full",
              placeholder: "例如 3000元/次"
            }, null, 8, _hoisted_96), [[_vModelText, model.priceDisplay]])])]), model.pricingType !== 'QUOTE' ? (_openBlock(), _createElementBlock("div", _hoisted_97, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.items, (item, itemIndex) => {
              return _openBlock(), _createElementBlock("div", {
                key: itemIndex,
                class: "grid grid-cols-1 gap-2 rounded-lg border border-slate-200 bg-white p-2 lg:grid-cols-6"
              }, [_createElementVNode("div", _hoisted_98, [_cache[97] || (_cache[97] = _createElementVNode("label", {
                class: "text-[11px] text-slate-500"
              }, "名称", -1)), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => item.name = $event,
                class: "form-input form-control-sm mt-1 w-full",
                placeholder: "名称"
              }, null, 8, _hoisted_99), [[_vModelText, item.name]])]), model.pricingType === 'TIER' ? (_openBlock(), _createElementBlock("div", _hoisted_100, [_createElementVNode("div", null, [_cache[98] || (_cache[98] = _createElementVNode("label", {
                class: "text-[11px] text-slate-500"
              }, "最小数量", -1)), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => item.minQty = $event,
                type: "number",
                class: "form-input form-control-sm mt-1 w-full"
              }, null, 8, _hoisted_101), [[_vModelText, item.minQty, void 0, {
                number: true
              }]])]), _createElementVNode("div", null, [_cache[99] || (_cache[99] = _createElementVNode("label", {
                class: "text-[11px] text-slate-500"
              }, "最大数量", -1)), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => item.maxQty = $event,
                type: "number",
                class: "form-input form-control-sm mt-1 w-full"
              }, null, 8, _hoisted_102), [[_vModelText, item.maxQty, void 0, {
                number: true
              }]])])])) : _createCommentVNode("", true), model.pricingType === 'RANGE' ? (_openBlock(), _createElementBlock("div", _hoisted_103, [_createElementVNode("div", null, [_cache[100] || (_cache[100] = _createElementVNode("label", {
                class: "text-[11px] text-slate-500"
              }, "最小价", -1)), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => item.priceMin = $event,
                type: "number",
                class: "form-input form-control-sm mt-1 w-full"
              }, null, 8, _hoisted_104), [[_vModelText, item.priceMin, void 0, {
                number: true
              }]])]), _createElementVNode("div", null, [_cache[101] || (_cache[101] = _createElementVNode("label", {
                class: "text-[11px] text-slate-500"
              }, "最大价", -1)), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => item.priceMax = $event,
                type: "number",
                class: "form-input form-control-sm mt-1 w-full"
              }, null, 8, _hoisted_105), [[_vModelText, item.priceMax, void 0, {
                number: true
              }]])])])) : _createCommentVNode("", true), model.pricingType === 'FIXED' || model.pricingType === 'ITEMIZED' || model.pricingType === 'SUBSCRIPTION' || model.pricingType === 'TIER' ? (_openBlock(), _createElementBlock("div", _hoisted_106, [_cache[102] || (_cache[102] = _createElementVNode("label", {
                class: "text-[11px] text-slate-500"
              }, "价格", -1)), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => item.price = $event,
                type: "number",
                class: "form-input form-control-sm mt-1 w-full"
              }, null, 8, _hoisted_107), [[_vModelText, item.price, void 0, {
                number: true
              }]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_108, [_cache[103] || (_cache[103] = _createElementVNode("label", {
                class: "text-[11px] text-slate-500"
              }, "说明", -1)), _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": $event => item.note = $event,
                class: "form-input form-control-sm mt-1 w-full",
                placeholder: "可选"
              }, null, 8, _hoisted_109), [[_vModelText, item.note]])]), _createElementVNode("div", _hoisted_110, [_createElementVNode("button", {
                onClick: $event => removePriceItem(model, itemIndex),
                class: "text-xs text-red-500 hover:text-red-600"
              }, "移除", 8, _hoisted_111)])]);
            }), 128)), _createElementVNode("button", {
              onClick: $event => addPriceItem(model),
              class: "rounded-lg border border-slate-200 px-3 py-1 text-xs text-slate-700 hover:bg-slate-50"
            }, "新增价格项", 8, _hoisted_112)])) : (_openBlock(), _createElementBlock("div", _hoisted_113, " 面议类型无需配置价格项。 ")), _createElementVNode("div", _hoisted_114, [_createElementVNode("button", {
              type: "button",
              onClick: $event => removePriceModel(modelIndex),
              class: "btn-text-danger"
            }, "删除模型", 8, _hoisted_115)])]);
          }), 128))])], 512), [[_vShow, activeProductSection.value === 'pricing']])])], 512)]), _createElementVNode("div", {
            class: "flex justify-end gap-2 border-t border-slate-200 px-6 py-4 shrink-0"
          }, [_createElementVNode("button", {
            onClick: openFormPreview,
            class: "rounded-lg border border-primary-200 px-4 py-2 text-sm text-primary-700 hover:bg-primary-50"
          }, "预览小程序效果"), _createElementVNode("button", {
            onClick: closeProductModal,
            class: "rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700"
          }, "取消"), _createElementVNode("button", {
            onClick: submitProduct,
            class: "rounded-lg bg-primary-700 px-4 py-2 text-sm text-white hover:bg-primary-800"
          }, "保存")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(ProductDetailModal, {
          modelValue: showDetailModal.value,
          "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => showDetailModal.value = $event),
          "product-id": selectedDetailId.value,
          categories: categories.value
        }, null, 8, ["modelValue", "product-id", "categories"]), _createVNode(ApprovalDetailModal, {
          modelValue: showApprovalDetailModal.value,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => showApprovalDetailModal.value = $event),
          "instance-id": selectedApprovalInstanceId.value,
          type: "product",
          title: "审批详情"
        }, null, 8, ["modelValue", "instance-id"]), _createVNode(ProductPreviewModal, {
          modelValue: showPreviewModal.value,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => showPreviewModal.value = $event),
          "product-id": previewProductId.value,
          "preview-data": previewFormData.value
        }, null, 8, ["modelValue", "product-id", "preview-data"]), _createVNode(AppModal, {
          visible: showConfirmModal.value,
          size: "md",
          onClose: closeConfirmModal
        }, {
          default: _withCtx(() => [_cache[104] || (_cache[104] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-6 py-4"
          }, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "确认删除")], -1)), _createElementVNode("div", _hoisted_116, _toDisplayString(confirmMessage.value), 1), _createElementVNode("div", {
            class: "flex justify-end gap-2 border-t border-slate-200 px-6 py-4"
          }, [_createElementVNode("button", {
            onClick: closeConfirmModal,
            class: "rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteAction,
            class: "rounded-lg bg-red-500 px-4 py-2 text-sm text-white hover:bg-red-600"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};